import { render, staticRenderFns } from "./sendToPublic.vue?vue&type=template&id=809a6700"
import script from "./sendToPublic.vue?vue&type=script&lang=js"
export * from "./sendToPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports